import React, { useEffect, useState } from "react";
import { Polyline, useMap } from "react-leaflet";
import axios from "axios";
import L from "leaflet";

const RoadRoute = ({ from, to }) => {
  const [routePositions, setRoutePositions] = useState([]);
  const map = useMap();

  useEffect(() => {
    if (!from || !to) return;

    const fetchRoute = async () => {
      try {
        // OSRM expects lon,lat
        // Request alternatives to find the shortest path (less km)
        const response = await axios.get(`https://router.project-osrm.org/route/v1/driving/${from[1]},${from[0]};${to[1]},${to[0]}?overview=full&geometries=geojson&alternatives=true`);

        if (response.data.routes && response.data.routes.length > 0) {
          // Find the route with the shortest distance (less km)
          const bestRoute = response.data.routes.reduce((prev, curr) => (prev.distance < curr.distance ? prev : curr));

          const coordinates = bestRoute.geometry.coordinates;
          // GeoJSON is [lon, lat], Leaflet needs [lat, lon]
          const latLngs = coordinates.map((coord) => [coord[1], coord[0]]);
          setRoutePositions(latLngs);

          // Fit bounds to the route
          if (latLngs.length > 0) {
            const bounds = L.latLngBounds(latLngs);
            map.fitBounds(bounds, { padding: [50, 50] });
          }
        }
      } catch (error) {
        console.error("Error fetching route:", error);
      }
    };

    fetchRoute();
  }, [from, to, map]);

  return routePositions.length > 0 ? <Polyline positions={routePositions} color="blue" weight={4} opacity={0.7} /> : null;
};

export default RoadRoute;
